import React, { createContext, useContext, useEffect, useReducer } from 'react';
import { SettingsAreaContext } from '../../cnr/contexts/SettingsAreaContext';
import { ViewSettingsComponentContext } from '../../cnr/contexts/ViewSettingsComponentContext';
import { settingsMenuHandlers, settingsMenuInitialState, settingsMenuReducer, settingsMenu_fns } from '../../cnr/reducers/SettingsMenuReducer';
import { SettingParentContext } from './SettingParentContext';
import { currentHelpers } from '../../redirection/current';

/** 
* @description This is the 2nd Component/Provider for Settings: (`settingsAreaContext` > `SettingsMenuContext`)
* @state settingsMenu_state (`activeMenu`, `activeMenus`, `activeAll`,`allow`, `allowGroupMenuSort`, `appArea`, `appUser_fns`, `helpDisplayType`, `helpDocuments`, `helpOn`, `helpTopics`, `isGlobal`, `lsName`, `projectOptions`, `settingsConsole`, `selectedGroup`, `selectedGroupItem`, `sortGroupsByPermission`, `useCollapsibleMenus`, `useFlatMenuIcons`)
* @handlers settingsMenu_handlers ( `handleActiveAll`, `handleActiveMenu`, `handleActiveMenuGroup`, `handleMenuGroupItemClick`,  `handleShowSearch`, `handleUpdateAll`, `handleUpdateInit`, `handleAllowGroupMenuSort`)
* @functions settingsMenu_fns (`getCurrentConsoleSettings`,  `getSelectedGroupItem`, `getSettingsBaseItem`, `ammendDataGroupItem`) 
* 
*/
export const SettingsMenuContext = createContext();

const SettingsMenuProvider = (props) => {

  // settingsParentContext
  const settingsParentContext = useContext(SettingParentContext)
  const { states, handlers, fns } = settingsParentContext ?? {}
  const { paps_state } = states ?? {}
  const { appSettings_handlers, settingsFramework_handlers } = handlers ?? {}
  const { navigation_fns } = fns ?? {}
  const { handleGroupItem_left, handleGroupItem_right } = settingsFramework_handlers ?? {}
  const { appArea } = paps_state ?? {}

  // viewSettingsComponentContext
  const viewSettingsComponentContext = useContext(ViewSettingsComponentContext);
  const { handleShowSearch } = viewSettingsComponentContext ?? {}

  // settingsAreaContext
  const settingsAreaContext = useContext(SettingsAreaContext);
  const { settingsArea_state } = settingsAreaContext ?? {}
  const {
    allow,
    appArea: appArea_sa,
    isGlobal,
    helpDocs, //help_state
    helpOn, // appSettings_state
    settingsConsole,
    nonLandingView,
    pageOptions, // aps_global
    pathViews, // paps_stateFa
    productionSettings, // aps_global
    projectModules,
    projectOptions, // aps_global
    settingsOptions, //aps_global
    settingsOriginType,
  } = settingsArea_state ?? {}

  const { useCollapsibleMenus, sortGroupsByPermission, helpDisplayType, useFlatMenuIcons } = settingsOptions ?? {}
  const { helpTopics, helpDocuments, helpDocs: _helpDocs } = helpDocs ?? {}

  const handleGroupItem = isGlobal ? handleGroupItem_left : handleGroupItem_right
  const _helpDocuments = helpDocuments ? helpDocuments[(isGlobal ? 'vw' : 'vi')] : {}

  let lsName = 'activeMenus_'
  lsName += isGlobal ? 'global' : 'view'
  let initActive = currentHelpers.storageItem_get(lsName)

  if (!initActive) {
    initActive = { app: false, data: false, content: true, permissions: false, styling: true, view: true }
  } else {
    initActive = JSON.parse(initActive)
  }

  const init_state = {
    activeMenus: initActive,
    allow,
    appArea,
    helpDisplayType,
    helpDocuments: _helpDocuments,
    _helpDocs,
    helpOn,
    helpTopics,
    settingsConsole,
    isGlobal,
    lsName, // local
    pageOptions,
    projectModules,
    projectOptions, // aps_global via sac 
    sortGroupsByPermission,
    useCollapsibleMenus,
    useFlatMenuIcons,
  }

  // reducerState
  // settingsMenu_fns are set within SettingsMenuProvider
  const [settingsMenu_state, settingsMenu_dispatch] = useReducer(settingsMenuReducer, settingsMenuInitialState(init_state));
  const settingsMenu_handlers = settingsMenuHandlers(settingsMenu_dispatch, settingsMenu_state)

  // sets the allowed groups for the settings menu
  useEffect(
    () => {
      settingsMenu_handlers.handleUpdateInit(appArea, isGlobal)
    },
    // update if appUser or settingsDocName changes
    // eslint-disable-next-line react-hooks/exhaustive-deps 
    [appArea_sa]
  )

  const groupItemClick_fns = {
    handleGroupItem,
    handleShow_appDashboard: appSettings_handlers.handleShow_appDashboard,
    handleShowSearch,
    navigation_fns,
  }

  const _settingsMenu_fns = settingsMenu_fns(projectOptions, pageOptions, projectModules, groupItemClick_fns, pathViews, nonLandingView, settingsOriginType, productionSettings)

  const providerContext = () => <SettingsMenuContext.Provider value={{ settingsMenu_state, settingsMenu_handlers, settingsMenu_fns: _settingsMenu_fns }}>
    {props.children}
  </SettingsMenuContext.Provider>

  return providerContext()

}

export default SettingsMenuProvider